export default "__VITE_PUBLIC_ASSET__12b7f15b__"